import dynamic from "next/dynamic";
const FullParagraphComponent = dynamic(()=>import("./full-paragraph-component"));
import FullParagraphConfig from "./full-paragraph-config";
import FullParagraphAdvancedConfig from "./full-paragraph-advanced-config";
export default {
    FullParagraphComponent,
    FullParagraphConfig,
    FullParagraphAdvancedConfig
};
